
<template>
  <base-card>
    <template slot="title">
      {{ $t('tasks.mine')}}
    </template>
    <template v-slot:content>
      <div v-if="!loading && tasks.length">
        <task-small-card @click="handleClick" v-for="task in tasks" with_status class="mb-2" :key="task.id" :task="task"></task-small-card>
      </div>
      <card-loading-transparent v-if="loading"></card-loading-transparent>
      <div v-if="!loading && !tasks.length">
        {{ $t('tasks.none') }}
      </div>
    </template>
    <template slot="actions">
      <v-btn text small class="text-capitalize" :to="{name: 'Tasks'}" color="blue-grey">{{ $tc('see_all',1) }}</v-btn>
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';
// import TaskSmallCard from '../../shared/TaskSmallCard.vue';
// import BaseInfoCardMarker from '../../shared/base_components/BaseInfoCardMarker.vue';

export default {
  name: 'MyTasksCard',
  //mixins: [ validations ],
  components: {
    // TaskSmallCard
    // BaseInfoCardMarker
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      tasks: [
        // {name: 'Lorem', start_at: '12/12/1212', due_at: '12/12/1212'}, 
      ],
    }
  },
  methods: {
    handleClick(e){
      this.$router.push({name: 'ShowTask', params: {id: e.task_id}})
    },
    getTasks() {
      this.loading = true
      let filter = {
        mine: true,
        limit: 5,
        searches: {
          users_ids_in: [this.profile.id],
          use_type_eq: 1, //official
          status_in: [1, 20]
        },
        // sorts: [
        //   'due_at asc'
        // ]
      }
      Api.Task.index(filter).then(r=> r.data).then(d => {
        this.tasks = [...d]
      }).finally(()=> {
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getTasks()
  },
  computed: {
    ...mapState({
      profile: (state) => state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>